// Copyright © 2025 CATTLEytics Inc.

import { useQuery, UseQueryResult } from 'react-query';

import { api } from '../../common/utilities';
import { ApiResourceV1, HttpMethod, QueryKey } from '../../shared';

export function useSourceReport(reportName: string): UseQueryResult {
  return useQuery(
    [QueryKey.Reports, 'source', reportName],
    () =>
      api<any[]>(HttpMethod.Get, `${ApiResourceV1.ReportsSource}`, {
        params: {
          reportName,
        },
      }),
    {
      keepPreviousData: false,
      refetchOnWindowFocus: true,
    },
  );
}
